import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { getUserTickets } from '../../../slices/auth-slice';
import { H2, H3, P1, P2 } from '../../../styles/FontStyles';
import {
  Box,
  Flexed,
  SectionSeparator
} from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { getAkashaHubs, getEntryPackages } from '../Marketplace.actions';

import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';

import { AkashaGrid, GridItem } from './DexNet.styled';

import { Button } from '../../../components/common/Button/Button';
import Spinner from '../../../components/common/Spinner';

import packageDummy from '../../../assets/images/backoffice/litePackegeDummy.png';
import { CheckGreen, Icon } from '../../../styles/Icons';

import dex1 from '../../../assets/images/backoffice/ecoChain/ecoChain1.png';
import dex2 from '../../../assets/images/backoffice/ecoChain/ecoChain2.png';
import dex3 from '../../../assets/images/backoffice/ecoChain/ecoChain3.png';
import dex4 from '../../../assets/images/backoffice/ecoChain/ecoChain4.png';
import dex5 from '../../../assets/images/backoffice/ecoChain/ecoChain5.png';

import dex1Mobile from '../../../assets/images/backoffice/ecoChain/ecoChain1Mobile.png';
import dex2Mobile from '../../../assets/images/backoffice/ecoChain/ecoChain2Mobile.png';
// import dex3Mobile from '../../../assets/images/backoffice/dexNet/dexnetBanner3Mobile.png';
import dex4Mobile from '../../../assets/images/backoffice/ecoChain/ecoChain4Mobile.png';
import dex5Mobile from '../../../assets/images/backoffice/ecoChain/ecoChain5Mobile.png';

import dexCloud from '../../../assets/images/backoffice/dexNet/dexCloud.png';
import dexServer from '../../../assets/images/backoffice/dexNet/dexServer.png';

import { Desktop } from '../../Kyc/KycStyled';
import { Mobile } from '../../../App';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';

const packages = [
  {
    benefits: [
      { name: 'License Key' },
      { name: 'DexNode Hardware' },
      { name: '1 - Year Maintenance' }
    ],
    packageId: 1,
    name: 'Physical Server',
    price: 1500,
    image: dexServer
  },
  {
    benefits: [{ name: 'License Key' }, { name: '1 - Year Maintenance' }],
    packageId: 1,
    name: 'DexNet Cloud',
    price: 1550,
    image: dexCloud
  },
  {
    benefits: [{ name: 'License Key' }, { name: '1 - Year Maintenance' }],
    packageId: 1,
    name: 'DexNet Cloud',
    price: 1050,
    image: dexCloud
  },
  {
    benefits: [{ name: 'License Key' }, { name: '1 - Year Maintenance' }],
    packageId: 1,
    name: 'DexNet Cloud',
    price: 550,
    image: dexCloud
  },
  {
    benefits: [{ name: 'License Key' }, { name: '1 - Year Maintenance' }],
    packageId: 1,
    name: 'DexNet Cloud',
    price: 250,
    image: dexCloud
  }
];

export const DexNet = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { loading, hubs } = useSelector((state) => state.marketplace);

  const firstHub = [hubs[0]];

  useEffect(() => {
    dispatch(getEntryPackages());
    dispatch(getUserTickets());
  }, [dispatch]);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  const [selectedHub, setSelectedHub] = useState(packages?.[0] || null);
  const [modal, setModal] = useState(false);

  const blue = colors.primary900;
  const green = '#74F88A';

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <Desktop>
        <img
          src={dex1}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />
      </Desktop>
      <Mobile>
        <img
          src={dex1Mobile}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />
      </Mobile>
      <Box dark br='30px'>
        <H3 color={colors.neutral900} mb='22'>
          DexNet Packages
        </H3>

        <AkashaGrid>
          {hubs.map((hub, index) => (
            <GridItem
              style={{ borderColor: index === 0 ? green : blue }}
              key={index}
              selected={selectedHub?.id === hub?.id}
              onClick={() => handleSeeDetails(hub)}>
              <img src={hub.image} style={{ width: '100%' }} />

              <div>
                <Flexed column center>
                  <H3 color={index === 0 ? green : blue} mb='4' mt='30'>
                    {hub.name}
                  </H3>
                </Flexed>
                <P1 mb='30' color={index === 0 ? green : blue}>
                  {formatUSDNoDecimals(hub.price)} {USDT}
                </P1>

                <Flexed height='100px'>
                  <div>
                    {hub?.benefits?.map((name, i) => {
                      return (
                        <Flexed center between gap='50px' key={i} mb='12'>
                          <Flexed center gap='5px'>
                            <Icon color={index === 0 ? green : blue}>
                              <svg
                                width='16'
                                height='15'
                                viewBox='0 0 16 15'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'>
                                <path
                                  d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                                  fill='#53C0F2'
                                />
                              </svg>
                            </Icon>
                            <P2 left color={colors.neutral0} key={i}>
                              {name}
                            </P2>
                          </Flexed>
                        </Flexed>
                      );
                    })}
                  </div>
                </Flexed>

                <SectionSeparator margin='40px 0' />
              </div>

              <Button
                color={index === 0 ? green : blue}
                w='100%'
                wSM='100%'
                onClick={() => handleSelectPackage(hub)}>
                Buy {hub.name}
              </Button>
            </GridItem>
          ))}
        </AkashaGrid>
      </Box>
      <Desktop>
        <img
          src={dex2}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />

        <Flexed gap='20px' width='100%'>
          <Flexed width='50%'>
            <img
              src={dex3}
              alt='trading'
              style={{ width: '100%', marginBottom: 20 }}
            />
          </Flexed>

          <Flexed width='50%'>
            <img
              src={dex4}
              alt='trading'
              style={{ width: '100%', marginBottom: 20 }}
            />
          </Flexed>
        </Flexed>
        <img
          src={dex5}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />
      </Desktop>

      <Mobile>
        <img
          src={dex2Mobile}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />
        <img
          src={dex3}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />
        <img
          src={dex4Mobile}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />
        <img
          src={dex5Mobile}
          alt='trading'
          style={{ width: '100%', marginBottom: 20 }}
        />
      </Mobile>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};
